import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Route {

    HOME = '';

    DASHBOARD = 'dashboard';

    APPLICATION_ADD_EDIT = 'detail';

    APPLICATION_VIEW = 'view';

    APPLICATION_VIEW_V1 = 'preview';

    APPLICATION_SEARCH = 'search';

    PAYMENT_SUCCESS = 'confirmation';

    PAYMENT_SUCCESS_RAVE = 'confirmation-rave';

    PAYMENT_FAILURE = 'failure';

    PAYMENT_RECEIPT = 'receipt';

    LOGOUT = 'logout';

    PAGE_NOT_FOUND = '**';

    RAVE_PAYMENT_SUCCESS = 'rave-payment-success';

    RAVE_PAYMENT_FAIL = 'rave-payment-fail';

    PAYMENT_RESPONSE = 'payment-response';

    APPLICATION_PAYMENT = 'payment';

    SELECT_PAYMENT = 'select-payment';



}
